// Section Menu

import './index.scss';

export default class SectionMenu {
    constructor(root) {
        this.root = jQuery(root);
        this.nav = this.root.find('.tabbar-wrap');

        var menu = this.root;
        var select = menu.find('select.select');

        this.root.find('a').each(function() {
            var sectionId = jQuery(this).attr('data-elements');
            var searchStr = sectionId.split(',').map(x => '#c' + x).join(',');
            var sections = jQuery(searchStr);
            if (!sections.length) {
                jQuery(this).parent().remove();
                select.find('option[value="' + sectionId + '"]').remove();
            }
        });

        this.sly = new Sly(this.nav, {
            horizontal: true,
            itemNav: 'centered',
            smart: false,
            mouseDragging: 1,
            touchDragging: 1,
            moveBy: 900,
            speed: 300
        }).init();

        var self = this;

        this.slyPrev = this.root.find('.tabbar-prev');
        this.slyPrev.on('click', function(event) {
            self.sly.slideTo(self.sly.pos.dest - 500)
            self.updateButtons();
        });

        this.slyNext = this.root.find('.tabbar-next');
        this.slyNext.on('click', function(event) {
            self.sly.slideTo(self.sly.pos.dest + 500)
            self.updateButtons();
        });

        self.updateButtons();

        select.on('change', function(event) {
            if (this.value) {
                menu.find('a[data-elements="' + this.value + '"]').trigger('click');
            } else {
                jQuery('html, body').animate({ scrollTop: 0 }, 500);
            }
        });

        this.root.find('a').click(function(event) {
            event.preventDefault();

            var attr = jQuery(this).attr('data-elements');
            if (attr) {
                var sectionId = jQuery(this).attr('data-elements');
                var searchStr = '#c' + sectionId.split(',')[0];

                var section = jQuery(searchStr);
                if (section.length > 0) {
                    var scrollTop = Math.ceil(section.offset().top - parseInt(menu.outerHeight(true)));
                    jQuery('html, body').animate({ scrollTop: scrollTop }, 500);
                }
            }
        });

        this.updateActiveItem();
        this.updatePosition();

        this.root.addClass('active');
    }

    reload() {
        this.sly.reload();

        this.updateActiveItem();
        this.updatePosition();
    }

    resize() {
        this.sly.reload();

        this.updateActiveItem();
        this.updateButtons();
        this.updatePosition();
    }

    scroll() {
        this.updateActiveItem();
        this.updatePosition();
    }

    updateActiveItem() {
        var self = this;
        var menu = this.root;
        var height = menu.outerHeight(true);
        var y = jQuery(window).scrollTop() + height;

        menu.find('a').each(function() {
            var link = jQuery(this);
            var active = false;

            var sectionId = link.attr('data-elements');
            var searchStr = sectionId.split(',').map(x => '#c' + x).join(',');
            var sections = jQuery(searchStr);
            sections.each(function(i, el) {
                var section = jQuery(el);
                var sectionY = section.offset().top;
                var sectionH = section.outerHeight();

                if (sectionY <= y && y < sectionY + sectionH) {
                    active = true;
                }
            });

            if (active) {
                link.addClass('active');
                menu.find('select.select').val(sectionId);

                var position = self.sly.getPos(link.parent());
                self.sly.slideTo(position.center);
                self.updateButtons();
            } else {
                link.removeClass('active');
            }
        });

        if (!menu.find('a.active').length) {
            menu.find('select.select').val('');
        }
    }

    updateButtons() {
        if (this.sly.pos.dest == this.sly.pos.start) {
            this.slyPrev.addClass('disabled');
        } else {
            this.slyPrev.removeClass('disabled');
        }

        if (this.sly.pos.dest == this.sly.pos.end) {
            this.slyNext.addClass('disabled');
        } else {
            this.slyNext.removeClass('disabled');
        }

        if (!this.slyPrev.hasClass('disabled') ||
            !this.slyNext.hasClass('disabled')) {
            this.root.addClass('nextprev');
        } else {
            this.root.removeClass('nextprev');
        }
    }

    updatePosition() {
        var menu = this.root.get(0);
        var wrap = menu.parentElement;

        var header = jQuery('.site-header');
        var headerOffset = 0;
        if (header.length) {
            headerOffset = parseInt(header.css('top')) + header.outerHeight(true);
        }

        wrap.style.height = menu.offsetHeight + 'px';
        if (wrap.getBoundingClientRect().top - headerOffset >= 0) {
            menu.classList.remove('fixed');
            menu.style.top = 0 + 'px';

            header.removeClass('no-shadow');
        } else {
            menu.classList.add('fixed');
            menu.style.top = headerOffset + 'px';

            header.addClass('no-shadow');
        }
    }
}
